import { Component, Input } from '@angular/core';

export interface TaxData {
  icon: string;
  description: string;
  title: string;
  links: Array<{
    icon: string;
    description: string;
    url: string;
  }>;
}

@Component({
  selector: 'fcp-section-tax',
  templateUrl: './section-tax.component.html',
  styleUrls: ['./section-tax.component.scss']
})
export class SectionTaxComponent {

  @Input() public tax: TaxData;

}
